export const stub = () => {
  return undefined;
};
